import { Bookmark } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// Bookmark toggle overlaid on a listing cover; `saved` is a Set of product ids.
export const SaveButton = ({ productId, saved, setSaved, className = "top-2 right-2" }) => {
  const on = saved.has(productId);
  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    setSaved((s) => { const n = new Set(s); on ? n.delete(productId) : n.add(productId); return n; });
    try {
      if (on) await api.delete(`/products/${productId}/save`);
      else { await api.post(`/products/${productId}/save`); toast.success("Saved for later, find it in Community"); }
    } catch (err) {
      setSaved((s) => { const n = new Set(s); on ? n.add(productId) : n.delete(productId); return n; });
      toast.error(err?.response?.data?.detail || "Couldn't update saved notes");
    }
  };
  return (
    <button type="button" onClick={toggle} data-testid={`save-btn-${productId}`} aria-pressed={on}
      aria-label={on ? "Remove from saved" : "Save for later"} title={on ? "Saved" : "Save for later"}
      className={`absolute z-10 h-8 w-8 rounded-full bg-black/55 backdrop-blur-sm flex items-center justify-center transition-transform active:scale-90 hover:bg-black/75 ${className}`}>
      <Bookmark className={`h-4 w-4 transition-colors ${on ? "fill-[#3B82F6] text-[#3B82F6]" : "text-white"}`} />
    </button>
  );
};
